/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_GardenInputs */

const cs_enum_garden = /** @type {(inputs: Enum_GardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahrada`)
};

const en_enum_garden = /** @type {(inputs: Enum_GardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garden`)
};

/**
* | output |
* | --- |
* | "Garden" |
*
* @param {Enum_GardenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_garden = /** @type {((inputs?: Enum_GardenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_GardenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_garden(inputs)
	return cs_enum_garden(inputs)
});